import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import {
  RoutingService
} from "@spartacus/core";
import { KnBrCheckoutService } from "src/app/services/kn-br-checkout-service";

@Component({
    selector: "edit-cart-confirmation-modal",
    templateUrl: "./edit-cart-confirmation-modal.component.html",
    styleUrl: "./edit-cart-confirmation-modal.component.scss",
})
export class EditCartConfirmationModalComponent {
  @Input() destinationUrl: string;
  constructor(
    private ngbActiveModal: NgbActiveModal,
    protected routing: RoutingService,
    private knBrCheckoutService : KnBrCheckoutService
  ) {}

  closeConfirmationPopUp() {
    this.ngbActiveModal.close();
  }
  confirmToGoToCart() {
  this.knBrCheckoutService.removePaymentInfo().subscribe({
    next: () => {
      this.ngbActiveModal.close();
      this.routing.goByUrl(this.destinationUrl);
    },
    error: (err) => {
      this.ngbActiveModal.close();
      console.error('Failed to remove billing address:', err);
      this.routing.goByUrl(this.destinationUrl);
    }
  });
}

}
